import React from 'react'

const TechnicianProfile = () => {
  return (
    <div>TechnicianProfile</div>
  )
}

export default TechnicianProfile